
import { userData, isMac as isMac_1 } from "./Interface/Bridge.js";
import { shortDisplayMsg } from "./UI/UpdateHelpers.js";
import { printf, toFail, interpolate, concat, join } from "./fable_modules/fable-library-js.5.13.0/String.js";
import { empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.5.13.0/Seq.js";
import { countRender, dbg, publish, onErrorLogged, enabled, out, categoryNames, maskOfNames, setCategories, warn, recordException } from "./Shared/Log.js";
import { debugLevel, setDebugLevel } from "./Interface/JSHelpers.js";
import { displayView, init as init_1 } from "./UI/MainView.js";
import { Cmd_none } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { windowWidth_, TopMenu, Model, Msg, MenuCommand } from "./Model/ModelType.js";
import { add, tryFind, empty as empty_1 } from "./fable_modules/fable-library-js.5.13.0/Map.js";
import { curry2, Exception, jsOptions, defaultOf, comparePrimitives } from "./fable_modules/fable-library-js.5.13.0/Util.js";
import { renderDone, forceViewException, recordModel, publish as publish_1, runOnSidecarWithProgress, sendDesignToSidecar, forceException, setSimulateInRenderer } from "./UI/DevHarness.js";
import { tryUserLibrariesDirectory } from "./Interface/ComponentLibraries.js";
import { errorFilesNotification } from "./UI/Notifications.js";
import { openFolderInFileManager } from "./Interface/FilesIO.js";
import { head, tail, singleton as singleton_1, toArray, isEmpty, filter, map, ofArray, append as append_1 } from "./fable_modules/fable-library-js.5.13.0/List.js";
import { onCanvasWheel, writeCanvasScroll } from "./DrawBlock/SheetDisplay.js";
import { XYPos } from "./Common/CommonTypes.js";
import { instrumentInterval, getTimeMs, aggregate, InstrumentationControl, instrumentation } from "./Common/TimeHelpers.js";
import { Sidecar_Constants_latencyTestConfig, Sidecar_testLatency, WebWorker_Constants_workerTestConfig, WebWorker_testWorkers, Breadcrumbs_testAllHierarchiesBreadcrumbs, Breadcrumbs_testBreadcrumbs, MiscTests_testAssets, MiscTests_testMaps, Misc_makeEditorPopup, TestFonts_makeTextPopup, Memory_printProcessMemory, Memory_printListeners } from "./Playground.js";
import { icarusRunTestCases, icarusCompileTestCases, genDriverFiles, runPerformanceTests, runCompilerTests } from "./VerilogComponent/TestParser.js";
import { FSharpSet__Add, FSharpSet__Contains, empty as empty_2 } from "./fable_modules/fable-library-js.5.13.0/Set.js";
import { onWindowBlur, onKeyUp, onKeyDown, setContextFromModel, publishKeyLog } from "./UI/KeyBindings.js";
import { SimulationBudget_maxHeapBytes, SimulationBudget_maxTypedArrayBytes, SimulationBudget_formatBytes, SimulationBudget_setBudgetsFromMachine } from "./Simulator/SimTypes.js";
import { loadDemoProjectFromHash } from "./UI/TopMenuView.js";
import { update as update_1 } from "./UI/Update.js";
import { installBeforeUnloadWarning } from "./UI/BrowserSession.js";
import { crashPage } from "./UI/ExceptionReport.js";
import { enabled as enabled_1 } from "./Shared/Log.js";
import { ofNullable } from "./fable_modules/fable-library-js.5.13.0/Option.js";
import { Optic_Set, Optic_Set_op_HatEquals_Z147477F8 } from "./Common/Optics.js";
import { ProgramModule_run } from "./fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { ProgramModule_mkProgram, ProgramModule_withErrorHandler, ProgramModule_withSubscription } from "./fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Program_withReactBatched } from "./fable_modules/Fable.Elmish.React.5.6.0/react.fs.js";
import "../../src/Renderer/scss/main.css";
import "../../src/Renderer/scss/extra.css";



export const isMac = isMac_1;

let lastHandledMsg = undefined;

function nameOfMsg(msg) {
    try {
        const matchValue = shortDisplayMsg(msg);
        if (matchValue == null) {
            const matchValue_1 = (msg && typeof msg.cases === 'function' && typeof msg.tag === 'number') ? String(msg.cases()[msg.tag]) : '';
            return (matchValue_1 === "") ? "an unnamed message" : matchValue_1;
        }
        else {
            return matchValue;
        }
    }
    catch (matchValue_2) {
        return "a message shortDisplayMsg does not name";
    }
}

function whereFrom(stack, site) {
    return join("\n", toList(delay(() => append((stack !== "") ? singleton(stack) : ((site !== "") ? singleton(concat("  thrown at ", site)) : singleton("  no stack: an F# exception carries none, and this one was caught before V8 reported it")), delay(() => {
        const matchValue = lastHandledMsg;
        if (matchValue == null) {
            return empty();
        }
        else {
            return singleton(concat("  last message handled: ", nameOfMsg(matchValue)));
        }
    })))));
}

function recordThrownAt(source, site, thrown) {
    recordException(source, thrown instanceof Error ? String(thrown) : (thrown != null && typeof thrown.message === 'string' ? (((thrown.constructor && thrown.constructor.name) || 'exception') + ': ' + thrown.message) : String(thrown)), whereFrom(thrown && thrown.stack ? String(thrown.stack) : '', site));
}

function recordThrown(source, thrown) {
    recordThrownAt(source, "", thrown);
}

function installExceptionBoundary() {
    window.addEventListener("error", (ev) => {
        const ev_1 = ev;
        const file = ev_1.filename;
        const line = ev_1.lineno | 0;
        const col = ev_1.colno | 0;
        const site = ((file == null || file === 'undefined')) ? "" : (`${file}:${line}:${col}`);
        const thrown = ev_1.error;
        if ((thrown == null || thrown === 'undefined')) {
            recordException("window", ev_1.message, whereFrom("", site));
        }
        else {
            recordThrownAt("window", site, thrown);
        }
    });
    window.addEventListener("unhandledrejection", (ev_2) => {
        recordThrown("promise", ev_2.reason);
    });
}

installExceptionBoundary();

export function init() {
    setDebugLevel();
    return [init_1(), Cmd_none()];
}

/**
 * Already in the bootstrap record, which main fills from the same app.getPath call the old
 * get-user-data channel made - so this is now a lookup rather than a round trip.
 */
export function getUserAppDir() {
    return userData;
}

export function softInitialise(model, dispatch) {
}

export const menuSeparator = (() => {
    const sep = {};
    sep.type = "separator";
    return sep;
})();

export function attachExitHandler(dispatch) {
    window.issieBridge.ipc.onClosingWindow(() => {
        dispatch(new Msg(/* MenuAction */ 100, [MenuCommand.MenuExit, dispatch]));
    });
    window.issieBridge.ipc.onWindowLostFocus(() => {
        dispatch(new Msg(/* MenuAction */ 100, [MenuCommand.MenuLostFocus, dispatch]));
    });
}

let menuActions = empty_1({
    Compare: (x, y) => (comparePrimitives(x, y) | 0),
});

let nextMenuId = 0;

/**
 * Look up and run whatever main says was clicked.
 */
export function runMenuAction(id) {
    const matchValue = tryFind(id, menuActions);
    if (matchValue == null) {
        warn(concat("application menu: no action registered for \'", id, "\'"));
    }
    else {
        matchValue(defaultOf());
    }
}

/**
 * Make action menu item from name, opt key to trigger, and action.
 */
export function makeItem(label, accelerator, iAction) {
    const item = {};
    item.label = label;
    item.accelerator = accelerator;
    nextMenuId = ((nextMenuId + 1) | 0);
    const id = `issieMenu${nextMenuId}`;
    item.id = id;
    menuActions = add(id, iAction, menuActions);
    return item;
}

/**
 * Make role menu from name, opt key to trigger, and action.
 */
export function makeRoleItem(label, accelerator, role) {
    const item = makeItem(label, accelerator, (_arg) => {
    });
    item.role = role;
    return item;
}

/**
 * make conditional menu item from condition, name, opt key to trigger, and role
 */
export function makeCondRoleItem(cond, label, accelerator, role) {
    const item = makeItem(label, accelerator, (_arg) => {
    });
    item.role = role;
    item.visible = cond;
    return item;
}

/**
 * make  a conditional menu item from a condition,
 * name, opt key to trigger, and action
 */
export function makeCondItem(cond, label, accelerator, action) {
    const item = makeItem(label, accelerator, action);
    item.visible = cond;
    return item;
}

/**
 * A menu item which is visible only if in debug mode
 * (run dev or command line -D on binaries) and on windows.
 */
export function makeDebugItem(label, accelerator, option) {
    return makeCondItem(debugLevel() !== 0, label, accelerator, option);
}

/**
 * A menu item which is visible only if in debug mode
 * (run dev or command line -D on binaries) and on windows.
 */
export function makeWinDebugItem(label, accelerator, option) {
    return makeCondItem((debugLevel() !== 0) && !isMac, label, accelerator, option);
}

/**
 * Make
 */
export function makeElmItem(label, accelerator, action) {
    return jsOptions((item) => {
        item.label = label;
        item.accelerator = accelerator;
        item.click = ((_arg, _arg_1, _arg_2) => {
            action();
        });
    });
}

/**
 * Make a new menu from a list of menu items
 */
export function makeMenuGen(visible, topLevel, name, table) {
    const subMenu = {};
    subMenu.type = (topLevel ? "normal" : "submenu");
    subMenu.label = name;
    subMenu.submenu = Array.from(table);
    subMenu.visible = visible;
    return subMenu;
}

/**
 * Make a new menu from a list of menu items
 */
export function makeMenu(topLevel, name, table) {
    return makeMenuGen(true, topLevel, name, table);
}

/**
 * The only Electron menu Issie still has, and only in debug builds.
 * 
 * Nothing here carries an accelerator, and nothing here should. Electron registers a menu item's
 * accelerator globally and unconditionally, which is why the Sheet, Edit and View menus had to
 * go: they took the key before anything could ask whether it made sense in that context. A menu
 * with no accelerators takes nothing, so it can coexist with KeyBindings.
 * 
 * Everything users need from the old menus is on the renderer's own menu bar - Project, Sheets,
 * Edit and View in TopMenuView - or in a context menu.
 */
export function devMenu(dispatch) {
    return makeMenuGen(debugLevel() > 0, false, "Development", ofArray([makeDebugItem("Simulate In .NET Sidecar (default)", undefined, (_arg) => {
        dispatch(new Msg(/* ExecFuncInMessage */ 116, [(_arg_1, d) => {
            setSimulateInRenderer(false, d);
        }, dispatch]));
    }), makeDebugItem("Simulate In Renderer (deprecated)", undefined, (_arg_2) => {
        dispatch(new Msg(/* ExecFuncInMessage */ 116, [(_arg_3, d_1) => {
            setSimulateInRenderer(true, d_1);
        }, dispatch]));
    }), makeDebugItem("Open User Library Directory", undefined, (_arg_4) => {
        const matchValue = tryUserLibrariesDirectory();
        if (matchValue.tag === 1) {
            dispatch(new Msg(/* SetFilesNotification */ 79, [errorFilesNotification(concat("No user library directory: ", matchValue.fields[0]))]));
        }
        else {
            const path = matchValue.fields[0];
            openFolderInFileManager(path, (reason) => {
                dispatch(new Msg(/* SetFilesNotification */ 79, [errorFilesNotification(concat("Could not open ", path, ": ", reason))]));
            });
        }
    }), makeCondRoleItem((debugLevel() !== 0) && !isMac, "Hard Restart Issie", undefined, "forceReload"), makeMenuGen(debugLevel() > 0, false, "Log", append_1(ofArray([makeDebugItem("Off", undefined, (_arg_5) => {
        setCategories(0);
    }), makeDebugItem("Everything", undefined, (_arg_6) => {
        setCategories(2047);
    })]), map((name_1) => makeDebugItem(name_1.slice(0, 0 + 1).toLocaleUpperCase() + name_1.slice(1, name_1.length), undefined, (_arg_7) => {
        setCategories(maskOfNames(name_1));
    }), filter((name) => (name !== "all"), categoryNames)))), makeMenuGen(debugLevel() > 0, false, "Play", ofArray([makeDebugItem("Heap", undefined, (_arg_8) => {
        const usedHeapSize = (performance.memory.usedJSHeapSize) / 1000000;
        const maxHeapSize = (performance.memory.totalJSHeapSize) / 1000000;
        const heapUsage = (usedHeapSize / maxHeapSize) * 100;
        out(`used heap ${interpolate("%.2f%P()", [usedHeapSize])}MB, max heap ${interpolate("%.2f%P()", [maxHeapSize])}MB, usage ${interpolate("%.2f%P()", [heapUsage])}%`);
    }), makeDebugItem("Initialise", undefined, (_arg_9) => {
        dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model, dispatch_1) => {
            softInitialise(model, dispatch_1);
        }, dispatch]));
    }), makeDebugItem("Toggle Showing Library Sheets", undefined, (_arg_10) => {
        dispatch(new Msg(/* UpdateModel */ 41, [(m) => (new Model(m.WindowWidth, m.KeyFocusPane, m.RunAfterRenderWithSpinner, m.UserData, m.WaveSim, m.WaveSimSheet, m.UISheetTrail, m.Spinner, m.Sheet, m.IsLoading, m.LastChangeCheckTime, m.LastSimulatedCanvasState, m.LastDetailedSavedState, m.CurrentSelected, m.LastSelectedIds, m.LastUsedDialogWidth, m.SelectedComponent, m.CurrentStepSimulationStep, m.CurrentTruthTable, m.TTConfig, m.RightPaneTabVisible, m.SimSubTabVisible, m.CircuitCheck, m.Hilighted, m.Clipboard, m.LastCreatedComponent, m.SavedSheetIsOutOfDate, m.PendingDragAddition, m.DragPlacement, m.ProjectBrowser, m.TopSheetChoiceDeclined, m.ComponentLibraries, m.OpenLibrary, m.CatalogueSearch, m.ArrayCopiesTyped, m.SimulateInRenderer, m.SidecarSession, m.ProbeRead, m.SidecarInFlight, m.SidecarBuildEndedMs, m.SidecarRunEndedMs, m.StepRunTarget, m.FetchedData, m.FetchedStructure, m.FailedFetch, m.StimulusGeneration, m.CurrentViewport, m.ViewportChangedAtMs, m.WaveScrollSettling, m.WaveScrollSerial, !m.ShowLibrarySheets, m.SuppressErrorPopups, m.OpenedLibrarySheets, m.ReadOnlyBaseline, m.CurrentProj, m.PopupViewFunc, m.SpinnerPayload, m.PopupDialogData, m.Notifications, m.TopMenuOpenState, m.SheetMenuPinned, m.DividerDragMode, m.WaveSimViewerWidth, m.ConnsOfSelectedWavesAreHighlighted, m.Pending, m.UIState, m.BuildVisible, m.CodeEditorState))]));
    }), makeDebugItem("Screen Reset", undefined, (_arg_11) => {
        out(`used heap before screen reset: ${interpolate("%.2f%P()", [(performance.memory.usedJSHeapSize) / 1000000])}MB`);
        dispatch(new Msg(/* SetTopMenu */ 85, [TopMenu.TransientClosed]));
    }), makeDebugItem("Set Scroll", undefined, (_arg_12) => {
        writeCanvasScroll(new XYPos(1000, 1000));
    }), makeDebugItem("Time Every Interval Over 1.5ms", undefined, (_arg_13) => {
        instrumentation(new InstrumentationControl(/* ImmediatePrint */ 0, [1.5, 1.5]));
        setCategories(enabled() | 512);
    }), makeDebugItem("Summarise Times Every 10s", undefined, (_arg_14) => {
        instrumentation(aggregate(10000));
        setCategories(enabled() | 512);
    }), makeDebugItem("Times Off", undefined, (_arg_15) => {
        instrumentation(InstrumentationControl.Off);
    }), makeDebugItem("Print Misc Performance Info", undefined, (_arg_16) => {
        Memory_printListeners();
        Memory_printProcessMemory();
        dispatch(Msg.SaveModel);
    }), makeDebugItem("Test Fonts", undefined, (_arg_17) => {
        TestFonts_makeTextPopup(dispatch);
    }), makeDebugItem("Test Editor", undefined, (_arg_18) => {
        Misc_makeEditorPopup(dispatch);
    }), makeWinDebugItem("Run Performance Check", undefined, (_arg_19) => {
        MiscTests_testMaps();
    }), makeWinDebugItem("Print Names of Static Asset Files", undefined, (_arg_20) => {
        MiscTests_testAssets();
    }), makeWinDebugItem("Test Breadcrumbs", undefined, (_arg_21) => {
        dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_1, dispatch_2) => {
            Breadcrumbs_testBreadcrumbs(model_1, dispatch_2);
        }, dispatch]));
    }), makeWinDebugItem("Test All Hierarchies Breadcrumbs", undefined, (_arg_22) => {
        dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_2, dispatch_3) => {
            Breadcrumbs_testAllHierarchiesBreadcrumbs(model_2, dispatch_3);
        }, dispatch]));
    }), makeDebugItem("Force Exception In A Menu Action", undefined, (ev) => {
        toFail(printf("User exception from menus"));
    }), makeDebugItem("Force Exception In Update", undefined, (_arg_23) => {
        out(forceException("update", dispatch));
    }), makeDebugItem("Force Exception In View (until restart)", undefined, (_arg_24) => {
        out(forceException("view", dispatch));
    }), makeDebugItem("Test Web Sorker Performance", undefined, (_arg_25) => {
        WebWorker_testWorkers(WebWorker_Constants_workerTestConfig);
    }), makeDebugItem("Test Sidecar Latency", undefined, (_arg_26) => {
        Sidecar_testLatency(Sidecar_Constants_latencyTestConfig);
    }), makeDebugItem("Send Design To Sidecar", undefined, (_arg_27) => {
        dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_3, _dispatch) => {
            sendDesignToSidecar(model_3, _dispatch);
        }, dispatch]));
    }), makeDebugItem("Run Design On Sidecar (1M cycles)", undefined, (_arg_28) => {
        dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_4, dispatch_4) => {
            runOnSidecarWithProgress(1000000, 250, undefined, model_4, dispatch_4);
        }, dispatch]));
    })])), makeMenuGen(debugLevel() > 0, false, "Verilog", ofArray([makeDebugItem("Run Verilog Tests", undefined, (_arg_29) => {
        runCompilerTests(undefined);
        out("compiler tests done");
    }), makeDebugItem("Run Verilog Performance Tests", undefined, (_arg_30) => {
        runPerformanceTests();
        out("performance tests done");
    }), makeDebugItem("Generate Driver Modules", undefined, (_arg_31) => {
        genDriverFiles();
    }), makeDebugItem("Icarus Compile Testcases", undefined, (_arg_32) => {
        icarusCompileTestCases();
    }), makeDebugItem("Icarus Run testcases", undefined, (_arg_33) => {
        icarusRunTestCases();
    })]))]));
}

/**
 * One-shot application setup, run as an Elmish subscription so it receives dispatch:
 * attach the Electron menu, the exit handler, and read the user data.
 * There is nothing to tear down - what it attaches lives as long as the app.
 */
export function attachMenusAndKeyShortcuts(dispatch) {
    const template = toList(delay(() => append(isMac ? singleton(makeRoleItem("Issie", undefined, "appMenu")) : empty(), delay(() => ((debugLevel() > 0) ? singleton(devMenu(dispatch)) : empty())))));
    dispatch(new Msg(/* ExecFuncInMessage */ 116, [(_arg, _arg_1) => {
        if (isEmpty(template)) {
        }
        else {
            window.issieBridge.ipc.onApplicationMenuCommand((id) => {
                runMenuAction(id);
            });
            const template_1 = toArray(map((value) => value, template));
            window.issieBridge.ipc.setApplicationMenu(template_1);
        }
    }, dispatch]));
    if (debugLevel() > 0) {
        let reported = empty_2({
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        });
        onErrorLogged((text) => {
            if (!FSharpSet__Contains(reported, text)) {
                reported = FSharpSet__Add(reported, text);
                dispatch(Msg.ProblemLogged);
            }
        });
    }
    attachExitHandler(dispatch);
    publishKeyLog();
    publish();
    publish_1(dispatch);
    SimulationBudget_setBudgetsFromMachine((window.issieBridge.diagnostics.systemMemory().total) * 1024, performance.memory.jsHeapSizeLimit);
    dbg(32, `simulation memory budget: ${SimulationBudget_formatBytes(SimulationBudget_maxTypedArrayBytes())} of step arrays, ${SimulationBudget_formatBytes(SimulationBudget_maxHeapBytes())} of heap`);
    dispatch(new Msg(/* ReadUserData */ 112, [getUserAppDir()]));
    dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model, dispatch_1) => {
        loadDemoProjectFromHash(model, dispatch_1);
    }, dispatch]));
    return {
        Dispose() {
        },
    };
}

export function view(model, dispatch) {
    return displayView(model, dispatch);
}

export function update(msg, model) {
    try {
        const patternInput = update_1(msg, model);
        const model$0027 = patternInput[0];
        setContextFromModel(model$0027);
        lastHandledMsg = msg;
        return [model$0027, patternInput[1]];
    }
    catch (e) {
        recordThrown(concat("update (", nameOfMsg(msg), ")"), e);
        return [model, Cmd_none()];
    }
}

export function view$0027(model, dispatch) {
    countRender();
    recordModel(model);
    installBeforeUnloadWarning(model);
    const start = getTimeMs();
    let drawn;
    try {
        if (forceViewException()) {
            throw new Exception("forced exception from the view");
        }
        const view_1 = view(model, dispatch);
        drawn = (((enabled_1() & 2) !== 0) ? instrumentInterval(">>>View", start, view_1) : view_1);
    }
    catch (e) {
        recordThrown("view", e);
        drawn = crashPage(e instanceof Error ? String(e) : (e != null && typeof e.message === 'string' ? (((e.constructor && e.constructor.name) || 'exception') + ': ' + e.message) : String(e)));
    }
    renderDone();
    return drawn;
}

function domListenerSub(eventName, makeHandler, dispatch) {
    const handler = curry2(makeHandler)(dispatch);
    document.addEventListener(eventName, handler);
    return {
        Dispose() {
            document.removeEventListener(eventName, handler);
        },
    };
}

function domNonPassiveListenerSub(eventName, makeHandler, dispatch) {
    const handler = curry2(makeHandler)(dispatch);
    const options = {
        passive: false,
    };
    document.addEventListener(eventName, handler, options);
    return {
        Dispose() {
            document.removeEventListener(eventName, handler);
        },
    };
}

function windowListenerSub(eventName, makeHandler, dispatch) {
    const handler = curry2(makeHandler)(dispatch);
    window.addEventListener(eventName, handler);
    return {
        Dispose() {
            window.removeEventListener(eventName, handler);
        },
    };
}

function focusCanvasElement() {
    const option_1 = ofNullable(document.getElementById('Canvas'));
    if (option_1 != null) {
        const element = option_1;
        element.focus();
    }
}

function isCanvasInteractionTarget(target) {
    return !((target && typeof target.closest === 'function' ? target.closest('#Canvas, #WholeApp') : null) == null);
}

function shouldHandleCanvasShortcuts(target) {
    if (isCanvasInteractionTarget(target)) {
        return (target && typeof target.closest === 'function' ? target.closest('input, textarea, select, [contenteditable=true], [contenteditable="true"], [contenteditable=""]') : null) == null;
    }
    else {
        return false;
    }
}

/**
 * The application's subscriptions, in Elmish 4 form: a constant set of identified
 * subscriptions, each returning its teardown. The set does not depend on the model, so each
 * subscription is started exactly once, as with Elmish 3's Cmd.ofSub.
 */
export function appSubscriptions(_model) {
    return ofArray([[singleton_1("menus"), attachMenusAndKeyShortcuts], [singleton_1("keydown"), (dispatch_1) => domListenerSub("keydown", (dispatch, e) => {
        onKeyDown(dispatch, e);
    }, dispatch_1)], [singleton_1("keyup"), (dispatch_3) => domListenerSub("keyup", (dispatch_2, e_1) => {
        onKeyUp(dispatch_2, e_1);
    }, dispatch_3)], [singleton_1("blur"), (dispatch_5) => windowListenerSub("blur", (dispatch_4, arg10$0040) => {
        onWindowBlur(dispatch_4, arg10$0040);
    }, dispatch_5)], [singleton_1("wheel"), (dispatch_7) => domNonPassiveListenerSub("wheel", (dispatch_6, e_2) => {
        onCanvasWheel(dispatch_6, e_2);
    }, dispatch_7)], [singleton_1("resize"), (dispatch_9) => windowListenerSub("resize", (dispatch_8, _arg) => {
        dispatch_8(new Msg(/* UpdateModel */ 41, [(m) => {
            const width = self.innerWidth;
            return (m.WindowWidth === width) ? m : Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, windowWidth_)(width)(m);
        }]));
    }, dispatch_9)], [singleton_1("contextmenu"), (dispatch_11) => domListenerSub("contextmenu", (dispatch_10, arg_2) => {
        ((e_3) => {
            if (shouldHandleCanvasShortcuts(e_3.target)) {
                e_3.preventDefault();
                focusCanvasElement();
                dispatch_10(new Msg(/* ContextMenuAction */ 120, [e_3]));
            }
        })(arg_2);
    }, dispatch_11)], [ofArray(["ipc", "context-menu-command"]), (dispatch_12) => {
        window.issieBridge.ipc.onContextMenuCommand((arg_3) => {
            const matchValue = ofArray(arg_3.split(","));
            let matchResult, item, menuType;
            if (!isEmpty(matchValue)) {
                if (!isEmpty(tail(matchValue))) {
                    if (isEmpty(tail(tail(matchValue)))) {
                        matchResult = 0;
                        item = head(tail(matchValue));
                        menuType = head(matchValue);
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    dispatch_12(new Msg(/* ContextMenuItemClick */ 121, [menuType, item, dispatch_12]));
                    break;
                }
                case 1: {
                    warn("unexpected callback argument sent from the main process");
                    break;
                }
            }
        });
        return {
            Dispose() {
            },
        };
    }], [ofArray(["browser", "context-menu-command"]), (dispatch_13) => {
        window.addEventListener('issie-context-menu-command', ((event) => {
            const arg_4 = Array.isArray(event.detail) ? (event.detail).join(',') : String((event.detail) ?? '');
            const matchValue_1 = ofArray(arg_4.split(","));
            let matchResult_1, item_1, menuType_1;
            if (!isEmpty(matchValue_1)) {
                if (!isEmpty(tail(matchValue_1))) {
                    if (isEmpty(tail(tail(matchValue_1)))) {
                        matchResult_1 = 0;
                        item_1 = head(tail(matchValue_1));
                        menuType_1 = head(matchValue_1);
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    dispatch_13(new Msg(/* ContextMenuItemClick */ 121, [menuType_1, item_1, dispatch_13]));
                    break;
                }
                case 1: {
                    warn("Unexpected browser context-menu callback argument.");
                    break;
                }
            }
        }));
        return {
            Dispose() {
            },
        };
    }]]);
}

ProgramModule_run(ProgramModule_withSubscription(appSubscriptions, Program_withReactBatched("app", ProgramModule_withErrorHandler((tupledArg) => {
    const context = tupledArg[0];
    recordThrown(concat("elmish (", (context.length > 120) ? (context.slice(undefined, 119 + 1) + "...") : context, ")"), tupledArg[1]);
}, ProgramModule_mkProgram(init, update, view$0027)))));

